export default __webpack_public_path__ + "static/media/icon-payments.8dcc95ef.svg";